function currency (value, c, d, t, p){
    var n = value,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    c = isNaN(c = Math.abs(c)) ? 2 : c;
    d = (d == undefined || d == null) ? "," : d;
    t = (t == undefined || t == null) ? "." : t;
    p = (p == undefined || p == null) ? "R$ " : p;
    return p + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

export default{
    currency
}


// WEBPACK FOOTER //
// ./resources/assets/js/loja/vue-filter.js